/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
(function() {
  // Add custom code below this line

  const logo = document.querySelector('.large-white-logo');
  if (logo) {
    window.addEventListener('scroll', function () {
      const scrollTop = window.scrollY;

      const fadeStart = 0;
      // const fadeEnd = 200;
      const isMobile = window.innerWidth <= 992;
      const fadeEnd = isMobile ? 30 : 80;
      const opacity = 1 - Math.min((scrollTop - fadeStart) / ((fadeEnd*2) - fadeStart), 1);

      logo.style.opacity = opacity;

      if (opacity === 0) {
        logo.style.visibility = 'hidden';
      } else {
        logo.style.visibility = 'visible';
      }
    });
  }

  // const adjustMainContentMargin = () => {
  //   const footerSections = document.querySelector('.footer-sections');
  //   const mainContent = document.querySelector('#MainContent');
  //   if (footerSections && mainContent) {
  //     const footerHeight = footerSections.offsetHeight;
  //     mainContent.style.marginBottom = `${footerHeight}px`;
  //   }
  // };

  // // Run on load
  // window.addEventListener('load', adjustMainContentMargin);

  // // Run on resize
  // window.addEventListener('resize', adjustMainContentMargin);

  // // Initial adjustment with a delay
  // setTimeout(adjustMainContentMargin, 500);

  
  const collectionNav = document.querySelector('.collection__nav');

  if (collectionNav) {
    const navOffsetTop = collectionNav.getBoundingClientRect().top + window.scrollY;
    const navHeight = collectionNav.offsetHeight;
  
    const placeholder = document.createElement('div');
    placeholder.style.height = `${navHeight}px`;
    placeholder.style.display = 'none';
    collectionNav.parentNode.insertBefore(placeholder, collectionNav);
  
    window.addEventListener('scroll', () => {
      if (window.scrollY >= navOffsetTop) {
        collectionNav.style.position = 'fixed';
        collectionNav.style.top = '0';
        collectionNav.style.width = '100%'; 
        collectionNav.style.zIndex = '1000'; 
        placeholder.style.display = 'block';
      } else {
        collectionNav.style.position = 'static';
        placeholder.style.display = 'none';
      }
    });
  }

const adjustProductTitleHeights = () => {
    const sections = document.querySelectorAll('.shopify-section');
    sections.forEach(section => {
        const grid = section.querySelector('#product-grid');
        if (!grid) return;

        const gridItems = Array.from(grid.querySelectorAll('.grid-item'));
        if (gridItems.length === 0) return;

        // Reset all heights first
        gridItems.forEach(item => {
            const title = item.querySelector('.product-item__title');
            if (title) title.style.height = '';
        });

        if (document.body.classList.contains('template-collection')) {
    // Group items by their offsetTop (visual row)
    const rows = {};
    gridItems.forEach(item => {
        const top = item.offsetTop;
        if (!rows[top]) rows[top] = [];
        rows[top].push(item);
    });

    Object.values(rows).forEach(rowItems => {
        let maxHeight = 0;
        rowItems.forEach(rowItem => {
            const title = rowItem.querySelector('.product-item__title');
            if (title) maxHeight = Math.max(maxHeight, title.offsetHeight);
        });
        rowItems.forEach(rowItem => {
            const title = rowItem.querySelector('.product-item__title');
            if (title) title.style.height = `${maxHeight}px`;
        });
    });
} else {
    // Fallback: set all to the same height
    let maxHeight = 0;
    gridItems.forEach(item => {
        const title = item.querySelector('.product-item__title');
        if (title) maxHeight = Math.max(maxHeight, title.offsetHeight);
    });
    gridItems.forEach(item => {
        const title = item.querySelector('.product-item__title');
        if (title) title.style.height = `${maxHeight}px`;
    });
}
    });
};
window.addEventListener('load', adjustProductTitleHeights);
window.addEventListener('resize', adjustProductTitleHeights);
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();